<template>
    <div>
        <div style="padding: 20px; border: 1px solid #ddd; border-radius: 5px" class="flex y-center flex-wrap">
            <div class="flex flex-wrap">
                <div class="flex mr40 y-center info-item">
                    <div class="color666 flex-item">{{ $t('notice.email_balance_available') }}</div>
                    <!-- 可用金额 -->
                    <b class="fs22 ml10 warning-color">¥{{ balance.balance }}</b>
                </div>
                <div class="flex mr40 y-center info-item">
                    <div class="color666 flex-item">{{ $t('notice.sms_price') }}</div>
                    <!-- 短信价格 -->
                    <b class="fs22 ml10 warning-color">¥{{ balance.sms_unit_price }}/{{ $t('notice.items' /* 条 */) }}</b>
                </div>
                <div class="flex y-center info-item">
                    <div class="color666 flex-item">{{ $t('notice.sms_sendable_count') }}</div>
                    <!-- 可发短信数 -->
                    <b class="fs22 ml10 warning-color">¥{{ balance.sms_items }}/{{ $t('notice.items' /* 条 */) }}</b>
                </div>
            </div>

            <a-button size="large" type="primary" style="width: 150px">{{ $t('notice.btn_recharge_online') }}</a-button>
            <!-- 在线充值 -->
        </div>

        <div class="mt15">
            <a target="_blank" :href="downloadTemplateUrl">
                <a-button type="primary">{{ $t('notice.download_template') }}</a-button>
                <!-- 下载模板 -->
            </a>
            <a target="_blank" :href="helpDocumentUrl">
                <a-button type="link">{{ $t('notice.help_doc' /* 帮助文档 */) }}</a-button>
            </a>
        </div>

        <p class="error-color mt10">{{ $t('notice.upload_excel_tip', { value: $t('web.mobile') }) }}</p>
        <!-- 温馨提示:上传Excel数据必须包含手机号码列并将手机号码放在第一列 -->

        <div class="mt10">
            <a-upload-dragger
                :action="uploadImageUrl"
                name="file_name"
                :data="{ type: 1 }"
                :before-upload="info => beforeUpload(info, 'file')"
                :headers="uploadHeaders"
                @change="handleFileChange"
                :showUploadList="false"
            >
                <a-icon style="font-size: 32px" class="theme-color" type="upload"></a-icon>
                <div class="mt10 fs16">{{ $t('notice.click_or_drag_upload') }}</div>
                <!-- 点击或者拖拽上传文件 -->
            </a-upload-dragger>
        </div>

        <a-spin tip="Loading..." :spinning="confirmLoading" style="width: 100%">
            <a-table v-if="dataSource.length" size="small" :rowKey="record => record.id" :dataSource="dataSource" :columns="columns" :pagination="false"></a-table>

            <a-form :form="form" v-if="dataSource.length">
                <a-form-item :label="$t('notice.click_insert_tag' /* 点击插入标签 */)">
                    <a-space>
                        <a-button @click="handleSelectTagEvent(item)" v-for="(item, key, index) in label_list" :key="index" type="primary" ghost>{{ key }}</a-button>
                    </a-space>
                </a-form-item>

                <a-form-item :label="$t('notice.please_enter_sms_content' /* 请输入短信内容 */)">
                    <a-textarea
                        @blur="handleBlur"
                        v-decorator="['content', { rules: [{ required: true, message: $t('notice.please_enter_sms_content') }] }]"
                        :placeholder="$t('notice.please_enter_sms_content')"
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                    ></a-textarea>
                    <div class="error-color" slot="extra">{{ $t('notice.sms_max_length_limit') }}</div>
                    <!-- 一次发放短信内容的最长字符数不超过500字符 -->
                </a-form-item>

                <a-form-item :label="$t('notice.sms_sign' /* 短信签名 */)">
                    <a-input
                        v-decorator="['sign', { initialValue: '会务通', rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('notice.sms_sign' /* 短信签名 */) }] }]"
                    />
                </a-form-item>

                <a-form-item class="t-c">
                    <a-button type="primary" style="width: 150px" size="large" @click="handelSubmit">{{ $t('notice.submit_button_text') }}</a-button>
                    <!-- 立即提交 -->
                </a-form-item>
            </a-form>
        </a-spin>
    </div>
</template>
<script>
import userApi from '@/request/apiList';
export default {
    name: 'NoticeSmsTabConfig',
    components: {},
    props: {},
    data() {
        return {
            form: this.$form.createForm(this),
            cursorPos: 0, //光标位置
            // 文件请求地址
            uploadImageUrl: userApi.sendUploadFile,
            // 请求头
            uploadHeaders: {},
            confirmLoading: false,
            // 文件上传受控列表
            fileList: [],
            fileStream: {},
            balance: {},
            dataSource: [], //成功列表 最多10条
            columns: [],
            label_list: [], //标签
            downloadTemplateUrl: '',
            helpDocumentUrl: ''
        };
    },
    methods: {
        handelSubmit() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    const formData = new FormData();
                    formData.append('file_name', this.fileStream);
                    formData.append('type', 1);
                    for (let key in values) {
                        formData.append(key, values[key]);
                    }
                    this.$confirm({
                        title: this.$t('web.tips' /* 温馨提示 */),
                        content: this.$t('notice.confirm_send_content' /* 确认发送吗？ */),
                        onOk: () => {
                            this.$request
                                .post({ url: 'sendCustomExecute', data: formData })
                                .then(res => {
                                    this.$message.success(this.$t('notice.send_success' /* 发送成功 */));
                                    this.dataSource = [];
                                    this.getSendBalance();
                                })
                                .catch(err => {
                                    this.confirmLoading = false;
                                });
                        }
                    });
                }
            });
        },
        // 富文本编辑器失去焦点
        handleBlur(e) {
            this.cursorPos = e.srcElement.selectionStart;
        },

        // 选择标签
        handleSelectTagEvent(item) {
            let content = String(this.form.getFieldValue('content'));
            if (content === undefined) {
                // 输入内容为空，直接插入
                this.form.setFieldsValue({
                    content: item
                });
            } else {
                let start = content.substring(0, this.cursorPos || 0);
                let end = content.substring(this.cursorPos || 0);
                start = start == 'undefined' ? '' : start;
                end = end == 'undefined' ? '' : end;
                this.form.setFieldsValue({
                    content: `${start || ''}${item}${end || ''}`
                });
            }
        },
        // 用户余额
        getSendBalance() {
            this.$request.get({ url: 'getSendBalance' }).then(res => {
                this.balance = res.data;
            });
        },
        // 上传前
        beforeUpload(file, type) {
            return new Promise((resolve, reject) => {
                this.fileStream = file;
                let regFile = true;
                // 其他文件的验证
                if (type == 'file') {
                    // 取后台上传的后缀配置
                    // let options = currItem.options || [];
                    let options = ['xlsx'];
                    // 获取当前上传的文件后缀
                    let suffix = file.name.split('.');
                    suffix = suffix[suffix.length - 1];
                    if (options.length && options.indexOf(suffix) == -1) {
                        regFile = false;
                        this.$message.error(this.$t('notice.please_upload_file', { type: options.join('|') } /* 请上传后缀为{type}的格式 */));
                        return resolve(regFile);
                    }
                }
                return resolve(regFile);
            });
        },

        // 上传文件修改
        handleFileChange(info) {
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
            fileList = fileList.map(file => {
                if (file.response) {
                    let { code, data, message } = file.response;
                    if (code == 200) {
                        this.label_list = data.label;
                        let index = 0;
                        this.columns = [];
                        this.dataSource = [];
                        for (const key in data.label) {
                            this.columns.push({
                                title: key,
                                dataIndex: 'id' + index
                            });
                            index++;
                        }
                        data.success_list.forEach((item, index) => {
                            this.dataSource[index] = { id: index };
                            item.forEach((it, idx) => {
                                this.dataSource[index]['id' + idx] = it;
                            });
                        });
                    } else {
                        this.$message.error(message);
                        file.status = 'error';
                    }
                }
                return file;
            });
            this.fileList = fileList;
        }
    },
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
        this.getSendBalance();
    }
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 768px) {
    .info-item {
        .fs22 {
            font-size: 14px;
        }
    }
}
</style>
